import { Divider, Group, MantineTheme, Paper, Text } from '@mantine/core'

type Props = {
  maturingPrincipal: number
  newLoansTotal: number
  newLoansLabel?: string
  withPik?: boolean
  pikCapitalizedAmount?: number
}

const formatCurrency = (value: number): string => {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export default function SplitSummaryBar({
  maturingPrincipal,
  newLoansTotal,
  newLoansLabel = 'New Loans Total',
  withPik = false,
  pikCapitalizedAmount = 0,
}: Props) {
  const expectedTotal = withPik
    ? maturingPrincipal + pikCapitalizedAmount
    : maturingPrincipal
  const difference = newLoansTotal - expectedTotal
  const absDifference = Math.abs(difference)

  let differenceLabel: string
  let differenceColor: string
  if (Math.abs(difference) < 0.005) {
    differenceLabel = withPik ? 'Matched' : 'Even'
    differenceColor = withPik ? 'teal.7' : 'dimmed'
  } else if (difference > 0) {
    differenceLabel = withPik ? 'Over' : 'New Borrowing'
    differenceColor = withPik ? 'red.7' : 'teal.7'
  } else {
    differenceLabel = withPik ? 'Under' : 'Paydown'
    differenceColor = withPik ? 'red.7' : 'orange.7'
  }

  return (
    <Paper
      radius={10}
      p="sm"
      sx={(theme: MantineTheme) => ({ backgroundColor: theme.colors.gray[0] })}
    >
      <Group position="apart" noWrap>
        <Group spacing="xs" noWrap>
          <Text fz="11px" color="dimmed">
            Maturing Principal
          </Text>
          <Text fz="11px" weight={600}>
            {formatCurrency(maturingPrincipal)}
          </Text>
        </Group>

        <Divider orientation="vertical" />

        {withPik && (
          <>
            <Group spacing="xs" noWrap>
              <Text fz="11px" color="dimmed">
                PIK Capitalized
              </Text>
              <Text fz="11px" weight={600}>
                {formatCurrency(pikCapitalizedAmount)}
              </Text>
            </Group>

            <Divider orientation="vertical" />
          </>
        )}

        <Group spacing="xs" noWrap>
          <Text fz="11px" color="dimmed">
            {newLoansLabel}
          </Text>
          <Text fz="11px" weight={600}>
            {formatCurrency(newLoansTotal)}
          </Text>
        </Group>

        <Divider orientation="vertical" />

        <Group spacing="xs" noWrap>
          <Text fz="11px" color="dimmed">
            Difference — {differenceLabel}
          </Text>
          <Text fz="11px" weight={600} color={differenceColor}>
            {formatCurrency(absDifference)}
          </Text>
        </Group>
      </Group>
    </Paper>
  )
}
